import { createApp } from 'vue'
import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// import './assets/theme/index.css';
// import './style.css'
// import 'animate.css'
// import router from "@/router";
// import App from './App.vue';
// import { setupStore } from "@/store";


// // 修改主题颜色
// const el = document.documentElement
// // 设置 css 变量
// el.style.setProperty('--el-color-primary', '#52C443')

// const app = createApp(App)
// setupStore(app);
// app.use(ElementPlus)
// app.use(router)
// app.mount('#app')

import { isMobile } from '@/utils/tools';
// 动态导入并挂载对应项目的根组件
const initApp = async () => {
  let app;
  if (isMobile()) {
    // 移动端：导入移动端根组件和路由
    const { default: MobileApp } = await import('@/m/App.vue');
    const { default:mobileRouter } = await import('@/m/router');
    app = createApp(MobileApp);
    app.use(mobileRouter);
    await import('@/m/assets/theme/index.css');
    await import('@/m/style.css');
    await import('vant/es/dialog/style');
    await import('vant/es/image-preview/style');
    await import('vant/es/toast/style');
    await import('vant/es/notify/style');
    await import('jweixin-module');
    await import('@vant/touch-emulator');
    const CryptoJS =  await import('crypto-js');
    CryptoJS.SHA1('Message').toString();
    if(!crypto.subtle){
        crypto.subtle = {
            digest:async(obj,buffer)=>{
                return CryptoJS.SHA1(buffer).toString()
            }
        }
    }
    const  { setupStore } = await import("@/m/store");
    setupStore(app);
  } else {
    // PC端：导入PC端根组件和路由
    const { default: PcApp } = await import('./App.vue');
    const { default: pcRouter } = await import('@/router');
    app = createApp(PcApp);
    app.use(pcRouter);
    await import('@/assets/theme/index.css');
    await import('@/style.css');
    await import('animate.css');
    const  { setupStore } = await import("@/store");
    setupStore(app);
    // 修改主题颜色
    const el = document.documentElement
    // 设置 css 变量
    el.style.setProperty('--el-color-primary', '#52C443')
  }
  app.use(ElementPlus)
  app.mount('#app');
};

initApp()